import { buildDiagnosisResult } from './builders';
import type { DiagnosisResultContent } from './types';

/** PALE（グルメ弾丸ハンター） */
const paleContent: DiagnosisResultContent = {
  code: 'PALE',
  name: 'グルメ弾丸ハンター',
  catchphrase: '食べるために旅する、1日7食も余裕のグルメ戦士',
  rarity: 4,
  style:
    '「食べること」が旅の主目的。事前に名店をリストアップし、アクティブに動き回りながら冒険グルメと新体験を両立する。ミシュラン星付きから屋台まで幅広く攻め、効率よく「食の制覇」を目指す。計画と行動力で、短い滞在でも最大の食体験を引き出すタイプ。',
  strengths: [
    { lead: '食の網羅力が高い', text: '計画と行動力で名店・穴場を効率よく制覇し、旅の密度を上げられる。' },
    { lead: '満足度が爆上がりしやすい', text: '食を軸に動くため、達成感と満足感が旅全体に波及する。' },
    { lead: '初体験グルメに強い', text: '新しい店・体験型グルメを積極的に取り入れ、記憶に残る旅にしやすい。' },
  ],
  weaknesses: [
    { lead: 'ペースが速すぎると疲弊', text: '食べ歩きの勢いが上がると、同行者がついていけないことがある。' },
    { lead: '予約ミスが致命傷', text: '計画型ゆえ、行きたい店が取れないとモチベが急落しやすい。' },
    { lead: '観光より食が優先', text: '景色より次の店が気になり、非食事スポットが後回しになりがち。' },
  ],
  aaru: [
    { icon: 'utensils', text: '1日5〜7食スケジュール' },
    { icon: 'coffee', text: '食べログ予約は2ヶ月前' },
    { icon: 'camera', text: '写真フォルダ料理率98%' },
    { icon: 'utensils', text: '帰国時スーツケース半分が調味料' },
    { icon: 'msg', text: '「次どこ食べる？」が口癖' },
  ],
  manual: {
    good: '店選びに口出しOK／食の話を全力で聞く',
    ng: '「もうお腹いっぱい」「チェーンでいいじゃん」',
    tips: '移動は短距離タクシー／食事間は15分バッファ',
  },
  compatibility: {
    good: 'PALZ（食仲間）／SRLE（食いしん坊）',
    conflict: 'PRCZ（安心安定）／SACZ（脱力系）',
    tips: '予約表を共有／午前は軽め・午後から本番',
  },
  destinations: {
    domestic: '大阪（食い倒れの聖地）／福岡（博多ラーメン・屋台文化）',
    overseas: '台湾（24時間食べられる夜市天国）／バンコク（世界一の屋台文化）',
  },
};

export const paleDiagnosisResult = buildDiagnosisResult(paleContent);
